import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "111",
  height: "110",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M30.354 2.343A8 8 0 0 1 36.011 0h38.936a8 8 0 0 1 5.657 2.343l27.531 27.532a7.997 7.997 0 0 1 2.343 5.657v38.936a7.997 7.997 0 0 1-2.343 5.657l-27.531 27.532A8.001 8.001 0 0 1 74.947 110H36.01a8.001 8.001 0 0 1-5.657-2.343L2.822 80.125A8 8 0 0 1 .48 74.468V35.532a8 8 0 0 1 2.343-5.657L30.354 2.343Zm19.802 24.184a1 1 0 0 1 1-1.027H60.1a1 1 0 0 1 1 1.027l-.946 35a1 1 0 0 1-1 .973h-7.053a1 1 0 0 1-1-.973l-.946-35Zm11.536 51.328a6.214 6.214 0 1 1-12.428 0 6.214 6.214 0 0 1 12.428 0Z",
  fill: "#525052"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }